import { Pipe, PipeTransform } from '@angular/core';
import { EmployeeHelper } from '../helpers/employee.helper';
import { EmployeeForAssessments } from '../models/employee-for-assessments.model';
import { Employee } from '../models/employee.model';
import { State } from '../models/state.model';
import { StateService } from '../services';
import { ReviewPeriodHelper } from '../helpers/review-period.helper';
import { TranslateService } from '@ngx-translate/core';

@Pipe({name: 'employeeName'})
export class EmployeeNamePipe implements PipeTransform {

    private state: State;
    constructor(stateService: StateService, private translate: TranslateService) {
        this.state = stateService.state;
    }

  transform(value: EmployeeForAssessments, idPart = '') {
      if (!value) return '';
      
      if (idPart == 'identifier')
        return value.name + (value.employeeIdentifier ? ' ' + value.employeeIdentifier : '');
      else if (idPart == 'email')
        return value.name + ' ' + value.email;
      else
        return value.name;
  }
}

@Pipe({name: 'employeeDisplayName'})
export class EmployeeDisplayNamePipe implements PipeTransform {
    
    constructor() {}

  transform(value: Employee, separator = ' ') {
     return EmployeeHelper.getDisplayName(value);
  }
}

@Pipe({name: 'employeeEmail'})
export class EmployeeEmailPipe implements PipeTransform {

  transform(value: EmployeeForAssessments) {
      return value?.email ?? '';
  }
}

@Pipe({name: 'employeeIdentifier'})
export class EmployeeIdentifierPipe implements PipeTransform {

  transform(value: EmployeeForAssessments) {
      return value?.employeeIdentifier ?? '';
  }
}

@Pipe({name: 'employeeType'})
export class EmployeeTypePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: EmployeeForAssessments) {
      if (!value) return '';
      if (value.isSelf) return '';
      return !value.isContractor ? '' : this.translate.instant('EMPLOYEE_PIPE.CONTRACTOR');
  }
}

@Pipe({name: 'employeeReviewState'})
export class EmployeeReviewStatePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: EmployeeForAssessments) {
      if (!value) return '';

      const values = ['', this.translate.instant('EMPLOYEE_PIPE.INCOMPLETE'), this.translate.instant('EMPLOYEE_PIPE.COMPLETED')];
      return values[value.status];
  }
}
